import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const GitbookIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M11 17.01C11.08 17.01 11.15 17.03 11.23 17.06C11.3 17.09 11.36 17.13 11.42 17.19C11.47 17.24 11.51 17.3 11.54 17.38C11.57 17.45 11.59 17.52 11.59 17.6C11.59 17.68 11.57 17.75 11.54 17.82C11.51 17.9 11.47 17.96 11.41 18.01C11.36 18.07 11.3 18.11 11.22 18.14C11.15 18.17 11.08 18.19 11 18.19C10.84 18.18 10.7 18.12 10.59 18.01C10.48 17.9 10.41 17.75 10.41 17.6C10.41 17.44 10.48 17.29 10.59 17.18C10.7 17.07 10.85 17.01 11 17.01ZM20.19 13.39C20.11 13.39 20.04 13.38 19.96 13.35C19.89 13.32 19.83 13.27 19.77 13.22C19.72 13.16 19.68 13.1 19.65 13.03C19.62 12.96 19.6 12.88 19.6 12.8C19.6 12.73 19.62 12.65 19.65 12.58C19.68 12.51 19.72 12.44 19.77 12.39C19.83 12.34 19.89 12.29 19.96 12.26C20.04 12.23 20.11 12.22 20.19 12.22C20.34 12.22 20.49 12.28 20.6 12.39C20.71 12.5 20.77 12.65 20.77 12.81C20.77 12.96 20.71 13.11 20.6 13.22C20.49 13.33 20.34 13.39 20.19 13.39ZM20.19 10.99C19.71 10.99 19.25 11.19 18.91 11.53C18.57 11.86 18.38 12.33 18.38 12.81C18.38 13 18.41 13.19 18.47 13.38L12.49 16.57C12.32 16.33 12.1 16.13 11.84 15.99C11.58 15.86 11.29 15.79 11 15.79C10.31 15.79 9.68 16.18 9.38 16.8L4 13.96C3.43 13.67 3.01 12.73 3.05 11.88C3.08 11.44 3.23 11.09 3.46 10.96C3.61 10.87 3.79 10.88 3.98 10.98L4.01 11C5.44 11.75 10.1 14.21 10.3 14.3C10.6 14.44 10.77 14.49 11.29 14.25L20.92 9.24C21.06 9.18 21.23 9.05 21.23 8.84C21.23 8.56 20.93 8.44 20.93 8.44C20.39 8.18 19.54 7.79 18.72 7.4C16.96 6.58 14.97 5.65 14.1 5.19C13.34 4.79 12.74 5.13 12.63 5.19L12.42 5.3C8.48 7.24 3.22 9.85 2.92 10.04C2.38 10.36 2.05 11.01 2 11.82C1.94 13.1 2.59 14.44 3.52 14.93L9.21 17.86C9.27 18.29 9.49 18.68 9.82 18.97C10.15 19.25 10.57 19.41 11 19.41C11.48 19.41 11.93 19.22 12.27 18.89C12.61 18.55 12.8 18.1 12.81 17.63L19.07 14.23C19.39 14.48 19.79 14.62 20.19 14.62C20.67 14.62 21.13 14.43 21.47 14.09C21.81 13.75 22 13.29 22 12.8C22 12.32 21.81 11.86 21.47 11.52C21.13 11.18 20.67 10.99 20.19 10.99"
				fill="currentColor"
			/>
		</svg>
	)
}

export default GitbookIcon
